/**
 * Chemins publics alignés sur BrowserRouter (index.js) et "homepage" du package.json.
 * Utilisé pour les redirections window.location qui ignorent le basename React Router.
 */

function publicBasePath() {
  const fromEnv = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  if (fromEnv && fromEnv !== '.') {
    return fromEnv.startsWith('/') ? fromEnv : `/${fromEnv}`;
  }
  return '/boutique_kabala';
}

/**
 * URL absolue de la page de connexion (inclut le sous-dossier /boutique_kabala en prod).
 */
export function getLoginPath() {
  const path = `${publicBasePath()}/login`.replace(/\/+/g, '/');
  return `${window.location.origin}${path}`;
}
